import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import { store } from './store';
import { App as AntApp } from 'antd';
import { MessageProvider } from './utils/message';
import App from './App';

import 'antd/dist/reset.css';
import './styles/global.css';

// Theme configuration for consistent styling
const theme = {
  token: {
    colorPrimary: '#1890ff',
    borderRadius: 4,
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  components: {
    Typography: {
      titleMarginTop: 0,
      titleMarginBottom: 16,
    },
    Card: {
      borderRadiusLG: 8,
      boxShadowTertiary: '0 2px 8px rgba(0,0,0,0.06)',
    },
  },
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <Provider store={store}>
    <ConfigProvider theme={theme}>
      <AntApp>
        <MessageProvider>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <App />
          </BrowserRouter>
        </MessageProvider>
      </AntApp>
    </ConfigProvider>
  </Provider>
);
